import axios, { AxiosResponse } from 'axios'
import { IResponseData, IAxiosRequest } from '~/typings/index'
// import Message from '@/components/common/message'
import { CODES, setCodeMessage } from '@/utils/config'
import { Modal } from '@/components/common'
import { StoreUtils } from '@/store/StoreUtil'
// import { useModalConfirmHook } from '@/utils/hooks'

type _AxiosRequest = (url: string, params?: Record<string, any>) => Promise<IResponseData>

const STRATEGY_MAP: Record<string, () => void> = {
  '/certification/trainerTeam/joinUs': () => {
    // to do nothing
  },
  '/user/invitation/use': () => {
    // to do nothing
  },
  '/user/invitation/sales/use': () => {
    // to do nothing
  }
}

const TIMEOUT_DELAY = 20 * 1000

// 'http://10.1.188.22'

// 查看是否是本地
const isLocal = process.env.NODE_ENV === 'development'

// client， 本地开发加 /api/ 便于转发请求，发布后在任何环境都直接请求当前host
const PROD_BASE_URL = ''
const DEV_PROXY_BASE_URL = '/api'
const baseURL = isLocal ? DEV_PROXY_BASE_URL : PROD_BASE_URL

// 通用配置
const basicOptions = {
  timeout: TIMEOUT_DELAY,
  withCredentials: true
}

const httpFactory = (baseURL: string) => {
  const $http = axios.create({
    baseURL,
    ...basicOptions
  })
  $http.interceptors.request.use(
    (config) => {
      /**
       * ssr 时，siteId会通过__INITIAL_DATA__带过来
       * csr 时，手动存到window.siteId里
      */
      const siteId = window.__INITIAL_DATA__?.global?.siteInfo?.siteId || window.siteId || 1
      const languageId = window.__INITIAL_DATA__?.global.currentLangKey || window.languageId || null
      if (siteId && !config.url?.startsWith('/front-api/')) {
        if (config.method === 'get') {
          const params = config.params || {}
          config.params = Object.assign(params, {
            siteId: params.siteId || siteId,
            languageId: params.languageId || languageId
          })
        }
        if (config.method === 'post') {
          const data = config.data || {}
          config.data = Object.assign(data, {
            siteId: data.siteId || siteId,
            languageId: data.languageId || languageId
          })
        }
      }
      return config
    },
    async (error) => await Promise.reject(error)
  )
  $http.interceptors.response.use(
    (res): AxiosResponse<IAxiosRequest> => {
      const { data, config } = res
      const { code, message } = data
      const key = config.url
      if (STRATEGY_MAP[key || '']) {
        STRATEGY_MAP[key || '']?.()
      } else if (code !== CODES.SUCCESS && code !== CODES.NOT_FOUND && code !== CODES.NEED_LOGIN && code) {
        // Message.warning(setCodeMessage(code, message))
        const store = StoreUtils.store
        Modal.confirm({
          hideCancelButton: true,
          content: setCodeMessage(code, message),
          title: store?.state?.global.messages.en?.['Tips'] || 'Tips',
          okText: store?.state?.global.messages.en?.['Ok'] || 'Ok'
        })
      } else if (code === CODES.NOT_FOUND) {
        location.href = `/${window.prefix}/exception/notFound`
        // console.log('code === CODES.NOT_FOUND?', res)
      }
      return data
    },
    async (error) => {
      // 未登录的情况
      if (error.response && error.response.status === CODES.NEED_LOGIN) {
        const targetUrl = encodeURIComponent(location.pathname + location.search)
        location.href = `/user/sso/login?target=${targetUrl}`
      }
    }
  )
  return $http
}

// 客户端
const $http = httpFactory(baseURL)

// 请求node服务时的客户端，去掉了/api的baseUrl
const $localHttp = httpFactory('')

const get: _AxiosRequest = async function (url, params) {
  return await $http.get(url, { params })
}

const post: _AxiosRequest = async function (url, params) {
  return await $http.post(url, params)
}

const lget: _AxiosRequest = async function (url, params) {
  return await $localHttp.get(url, { params })
}

const put: _AxiosRequest = async function (url, data) {
  const param = new FormData() // 创建form对象
  param.append(data?.name || 'image', data?.file) // 通过append向form对象添加数据
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
  return await $http.post(url, param, config)
}

export {
  $http,
  $localHttp,
  get,
  lget,
  post,
  put
}
